export const ClearAnchor = () => {
    const url = new URL(window.location.href);
    url.hash = '';  // Clear the hash
    window.history.replaceState({}, document.title, url.toString());
}

export const GetAnchor = () => {
    const url = new URL(window.location.href);
    return url.hash ? url.hash.replace('#', '') : '';
}

export const AddAnchor = anchor => {
    if (typeof anchor !== 'string') {
        console.warn('Anchor must be a string.');
        return;
    }

    // Use the History API to update the URL with the new hash
    const url = new URL(window.location.href);
    url.hash = `#${anchor}`;  // Set the hash
    window.history.replaceState({}, document.title, url.toString());
}